import * as React from "react";
import BooleanField from "../../../metamodel/Fields/BooleanField";
import {OptionList} from "./OptionList";
import {FieldBehaviors} from "../../../metamodel/IField";
import {FieldFacet, IOption} from "../../types";

interface BooleanFilterFieldProps {
    field: BooleanField,
    facet: FieldFacet,
    selected: boolean | undefined,
    onChange?: (value: boolean|undefined) => void
}

const options = [
    {key: "true", name: "Ja"},
    {key: "false", name: "Nee"}
]

export default class BooleanFilterField extends React.Component<BooleanFilterFieldProps> {
    constructor(props: BooleanFilterFieldProps) {
        super(props);
    }

    public render(): React.ReactNode {
        const onChange = (f: IOption[]) => {
            if (!this.props.onChange) {
                return;
            }
            const val = f.map(o => o.key);
            if (val.indexOf("true") !== -1 && val.indexOf("false") !== -1) {
                this.props.onChange(undefined);
            } else if (val.indexOf("true") !== -1) {
                this.props.onChange(true);
            } else if (val.indexOf("false") !== -1) {
                this.props.onChange(false);
            } else {
                this.props.onChange(undefined);
            }
        };
        return <OptionList
            id={this.props.field.id}
            name={this.props.field.name}
            options={options}
            collapsed={(this.props.field.behaviors & FieldBehaviors.DefaultCollapsed) !== 0}
            facet={this.props.facet}
            selected={this.props.selected === undefined ? [] : (this.props.selected ? ["true"] : ["false"])}
            onChange={onChange}
        />;
    }

}


// WEBPACK FOOTER //
// ./src/homepage/components/filters/BooleanFilterField.tsx